import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_118: FaireProductEntity = {
  token: "starter_collection_118",
  type: "product",
  name: "Le Spritz - Ghia Soda",
  brandName: "Ghia",
  imageUrl:
    '"https://cdn.faire.com/fastly/dd29e2aaa96069a22e816f32fda83ee371557d26cde975b172843aac30c23ea1.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=851',
  priceDollars: 48,
  msrpDollars: 96,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
